import * as MP4Box from 'mp4box';

export async function detectMimeType(url: string): Promise<string> {
    const raw = await fetch(url).then((r) => r.arrayBuffer());
    const buf = Object.assign(raw, { fileStart: 0 });

    return new Promise((resolve, reject) => {
        const mp4box = MP4Box.createFile();
        mp4box.onReady = (info: any) => resolve(info.mime);
        mp4box.onError = reject;
        mp4box.appendBuffer(buf);
        mp4box.flush();
    });
}
